export default __webpack_public_path__ + "static/media/vika.e3dc84c9.jpeg";